var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.windowSize >= 576)?_c('desktop-checkout'):_c('mobile-checkout')
}
var staticRenderFns = []

export { render, staticRenderFns }